<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            :comboItems="comboTaskItems"
            itemText="codeName"
            itemValue="code"
            type="search"
            name="taskClassName"
            label="업무"
            v-model="searchParam.taskClassName"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <!-- 변경/추가 내역 목록 -->
    <c-table
      ref="table"
      title="변경/추가 내역 목록"
      :merge="grid.merge"
      :columns="grid.columns"
      :data="grid.data"
      :gridHeight="grid.height"
      selection="multiple"
      rowKey="taskId"
      @rowDblclick="rowDblclick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn v-if="editable" label="선택" icon="check" @btnClicked="select" />
          <c-btn label="검색" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'riskOccasion',
  props: {
    popupParam: {
      type: Object,
      default: function() {
        return {
        }
      },
    }
  },
  data() {
    return {
      grid: {
        merge: [
          { index: 0, colName: 'taskClassName' }
        ],
        columns: [
          {
            name: 'taskClassName',
            field: 'taskClassName',
            label: '업무',
            align: 'center',
            style: 'width:30%',
            sortable: false,
          },
          {
            name: 'taskTitle',
            field: 'taskTitle',
            label: '제목',
            align: 'left',
            style: 'width:70%',
            sortable: false,
          },
        ],
        data: [],
        height: '650px'
      },
      searchParam: {
        taskClassName: null,
      },
      comboTaskItems: [
        { code: '설비', codeName: '설비' },
        { code: '기계기구', codeName: '기계기구' },
        { code: '공정', codeName: '공정' },
        { code: '화학자재', codeName: '화학자재' },
        { code: '사고', codeName: '사고' },
      ],
      editable: true,
      listUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.ram.assessOccasion.task.url;
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    select() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '선택된 항목이 없습니다.', // 선택된 항목이 없습니다. 
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$emit('closePopup', selectData);
      }
    },
    rowDblclick(row) {
      if (this.popupParam.type === 'single') {
        this.$emit('closePopup', [row]);
      }
    },
  }
};
</script>
